import './offer.css';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import MenuPlans from './MenuPlans';

const PlanAnual = () => {
  const navigate = useNavigate();
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      fontFamily: 'Inter, Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
    }}>
      <MenuPlans />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 18 }}>
          <div style={{
            display: 'inline-block',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            padding: '8px 20px',
            borderRadius: 50,
            fontSize: 14,
            fontWeight: 600,
            marginBottom: 18,
            boxShadow: '0 4px 15px rgba(102, 126, 234, 0.18)'
          }}>
            Cel mai popular
          </div>
          <h1 style={{ fontSize: '2.3rem', fontWeight: 800, marginBottom: 8, color: '#1a202c', textAlign: 'center' }}>Plan Premium Anual</h1>
          <p style={{ color: '#4a5568', fontSize: '1.15rem', marginBottom: 0, textAlign: 'center', maxWidth: 420 }}>
            Economisești 290 lei față de lunar. Acces complet la toate beneficiile platformei.
          </p>
        </div>
        <div className="offerdiscount-card" style={{ margin: 0, boxShadow: '0 8px 32px rgba(102,126,234,0.10), 0 2px 8px rgba(22,199,158,0.10)' }}>
          <div className="offerdiscount-price" style={{ justifyContent: 'center' }}>
            <span className="offerdiscount-price-main">550 LEI</span>
            <span style={{ fontSize: '1.1rem', color: '#6b7280', fontWeight: 500 }}>/an</span>
          </div>
          <div style={{ color: '#764ba2', fontWeight: 600, fontSize: 15, marginBottom: 8, textAlign: 'center' }}>
            <span style={{ background: '#f3f0ff', borderRadius: 8, padding: '2px 10px', fontSize: 13, fontWeight: 500 }}>45.83 lei/lună</span>
          </div>
          <ul className="offerdiscount-benefits">
            <li><FontAwesomeIcon icon={faCheck} className="item-bifa" /> Tot ce oferă planul lunar</li>
            <li><FontAwesomeIcon icon={faCheck} className="item-bifa" /> Certificat de finalizare</li>
            <li><FontAwesomeIcon icon={faCheck} className="item-bifa" /> Acces prioritar la conținut nou</li>
            <li><FontAwesomeIcon icon={faCheck} className="item-bifa" /> Suport dedicat</li>
            <li><FontAwesomeIcon icon={faCheck} className="item-bifa" /> <span style={{ color: '#16c79e', fontWeight: 600 }}>Economisești 290 lei/an</span></li>
          </ul>
          <button
            className="offerdiscount-btn"
            style={{ marginBottom: 10 }}
            onClick={() => navigate('/facturare?plan=annual')}
          >
            Continua catre plata
          </button>
          <div style={{ color: '#16c79e', fontWeight: 500, fontSize: 14, marginTop: 6, textAlign: 'center' }}>
            <FontAwesomeIcon icon={faCheck} style={{ marginRight: 6 }} /> Garanție de rambursare 14 zile
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanAnual;
